import { Swiper } from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import type { SwiperOptions } from 'swiper/types';
import { classInstance } from '@/shared/helpers/helpers';

export class MainComplexesSlider {
	private readonly element: HTMLElement;
	private sliderElement!: HTMLElement;
	private buttonPrev!: HTMLElement;
	private buttonNext!: HTMLElement;
	private paginationElement!: HTMLElement;
	private slider!: Swiper;
	private sliderSettings = (): SwiperOptions => ({
		modules: [Navigation, Pagination],
		slidesPerView: 2,
		spaceBetween: 16,
		breakpoints: {
			700: {
				slidesPerView: 3
			},
			1000: {
				slidesPerView: 3,
				allowTouchMove: false
			},
			1200: {
				slidesPerView: 4,
			},
		},
		navigation: {
			prevEl: this.buttonPrev,
			nextEl: this.buttonNext,
		},
		pagination: {
			el: this.paginationElement,
			type: 'progressbar',
		},
	});

	constructor(element) {
		if (!element || window.app.classInstance.get(element)) return;
		this.element = element;

		this.init();
	}

	public init(): void {
		this.sliderElement = this.element.querySelector('.main-complexes__swiper') as HTMLElement;
		this.buttonPrev = this.element.querySelector('.slider-navigation__button--prev') as HTMLElement;
		this.buttonNext = this.element.querySelector('.slider-navigation__button--next') as HTMLElement;
		this.paginationElement = this.element.querySelector('.slider-navigation__pagination') as HTMLElement;
		this.slider = new Swiper(this.sliderElement, this.sliderSettings());
		classInstance.set(this.element, this);
	}

	public destroy(): void {
		classInstance.del(this, 'MainComplexesSlider');
		this.slider?.destroy();
		this.sliderElement = null;
		this.buttonPrev = null;
		this.buttonNext = null;
		this.paginationElement = null;
		this.slider = null;
	}
}
